import { environment } from '../../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import moment from 'moment-timezone';
import { constants } from 'zlib';


export const LocalURL = 'https://jsonplaceholder.typicode.com/';
export const GETREVENUE = 'posts';
export const LocalJsonUrl = 'assets/json';
export const randomTime = 5000;
export const IntervalToSyncMasterdata: number = 60000 * 60; // 60000 * 60; - per hour
export const EnterpriseEdition = '3';

/* Environment names */
export const environments = {
  envProd: 'production',
  envDev: 'dev',
  envStage: 'staging'
};

export const aiModule = {
  Requisition: 2,
}

export const letters = {
  c: 'c'
};


// export const IsLoadFromApp: boolean = environment.IsLoadFromApp;
function createUrl(actionName: string): string {
  // return `${environment.APIEndpoint}${actionName}`;
  return `${window.localStorage.getItem('apiUrl')}${actionName}`;
}

export const baseURL: string = environment.APIEndpoint;
/* api URL's */
const apiBaseURL: string = environment.APIEndpoint;

export const cSharpMethodType = {
  GET: 'GET',
  POST: 'POST'
};

export const cSharpURLs = {
  GetUserLogin: '/api/Account/Login',
  GetBarcode: 'api/Barcode',
  GetVoice: 'api/Voice',
  GetToken: 'api/token',
  GetSites: 'api/sites',
  PostUserDetails: 'api/user',
  Settings: 'api/settings',
  Synclocaldata: 'api/synclocaldata',
  GetSources: 'api/setup',
  GetBin: 'api/getbin',
  GetZone: 'api/getzones',
  GetInventory: 'api/inventory',
  PostTransaction: 'api/transaction',
  GetPhysicalInventory: 'api/physicalinventory',
  GetAboutApp: 'api/aboutApp',
  UpdateApp: 'api/updateApp',
  LoaderStop: 'api/LoaderStop',
  DeviceInfo: 'api/aboutdeviceinfo',
  ExportExcel: 'api/exportexcel',
  StoreTenant: 'api/getTenant',
  GetUserAccess: 'api/useraccess',
  UpdateRGuestUser: 'api/updateRGuestUser',
  GetODataCollection: 'api/getODataCollection',
  SaveODataCollection: 'api/saveODataCollection',
  GetSiteLocationIds: 'api/getSiteLocationIds',
  GetInventoryLinkedItemDetails: 'api/getInventoryLinkedItemDetails',
  GetApprovalLevel: 'api/getApprovalLevel',
  SaveLocalFile: 'api/SaveFile',
  GetUserConfig: 'api/GetUserConfig',
  GetPinExpiry: 'api/PinExpiry',
  SavePin:"api/SavePin"
};

export const cSharpModuleName = {
  InventoryList: 'InventoryList',
  LoadPhysicalInventory: 'LoadPhysicalInventory',
  NewRequisition: 'NewRequisition',
  NewTransfer: 'NewTransfer',
  NewSpoilage: 'NewSpoilage',
  NewPhysicalInventory: 'NewPhysicalInventory',
  NewPurchaseOrder: 'NewPurchaseOrder',
  NewReceiving: 'NewReceiving',
  Login: 'Login',
  SaveSettings: 'SaveSettings',
  SyncMasterdata: 'SyncMasterdata',
  SyncTransactionaldata: 'SyncTransactionaldata',
  TransactionRequisition: 'Requisition',
  TransactionTransfer: 'Transfer',
  TransactionSpoilage: 'Spoilage',
  TransactionPhysicalInventory: 'PhysicalInventory',
  TransactionPurchaseOrder: 'PurchaseOrder',
  OfflineTransaction: 'OfflineTransactions',
  OfflineAllTransaction: 'OfflineAllTransaction',
  OfflineRequisitionTransaction: 'OfflineRequisitionTransaction',
  OfflineTransferTransaction: 'OfflineTransferTransaction',
  OfflinePOTransaction: 'OfflinPOTransaction',
  OfflineSpoilageTransaction: 'OfflineSpoilageTransaction',
  Settings: 'Settings',
  GetODataCollection: 'GetODataCollection',
  SaveODataCollection: 'SaveODataCollection',
  UpdateRGuestUser : 'UpdateRGuestUser'
};

export const ComponentNameReferences = {
  NewRequisition: 'newRequisitionComponentRef',
  NewTransfer: 'newTransferComponentRef',
  InventoryList: 'inventoryComponentRef',
  NewSpoilage: 'newSpoilageComponentRef',
  LoadPhysicalInventory: 'LoadPhysicalInventoryRef',
  NewPhysicalInventory: 'newPhysicalInventoryComponentRef',
  NewPurchaseOrder: 'newPurchaseOrderComponentRef',
  LoadPurchaseOrderOffline: 'poOfflinePurchaseOrderComponentRef',
  Login: 'loginComponentRef',
  InventoryPackage: 'inventoryPackageComponentRef',
  InventoryDetails: 'inventoryItemDetailComponentRef',
  InventoryItems: 'inventoryItemsComponentRef',
  RequisitionPackage: 'requisitionPackageComponentRef',
  RequisitionRequestDetails: 'requisitionRequestDetailsComponentRef',
  NavBarComponent: 'NavBarComponentRef',
  ReceivingComponent: 'ReceivingComponentRef',
  SavedRequisitionDetails: 'savedRequisitionComponentRef',
  OfflineSavedPI: 'offlineSavedPIComponentRef',
  TransferDetails: 'transferDetailsComponentRef',
  TransferOffline: 'transferOfflineComponentRef',
  TransferPackage: 'transferPackageComponentRef',
  EditPurchaseOrder: 'editPurchaseOrderComponentRef',
  PurchaseOrderPackage: 'purchaseOrderPackageComponentRef',
  OfflineAllTransaction: 'savedOfflineTransactionComponentRef',
  OfflinePOTransaction: 'OfflinePurchaseorderComponentRef',
  OfflineTransferTransaction: 'OfflineTransferComponentRef',
  OfflineRequisition: 'OfflineRequisitionsComponentRef',
  OfflineSpoilageComponent: 'OfflineSpoilageComponentRef',
  OfflineReceivingComponent: 'OfflineReceivingComponentRef',
  OfflinePIComponent: 'OfflinePIComponentRef',
  savedSpoilageComponent: 'savedSpoilageComponentRef',
  spoilagePackageComponent: 'spoilagePackageComponentRef',
  SettingsComponent: 'settingsComponentRef',
  AboutComponent: 'AboutComponentRef',
  ReceivingLanding: 'receivingLandingComponentRef',
  NewReceiving: 'newReceivingComponentRef',
  MessageComponentRef:'MessageComponentRef',
  PasscodeComponentRef:'PasscodeComponentRef',
  ReceivingDetailsComponentRef:'receivingDetailsComponentRef',
  ItemListTableComponentRef: 'ItemListTableComponentRef',
  ErsHistoryComponentRef: 'ErsHistoryComponentRef',
  DatamagineAttachmentComponentRef: 'DatamagineAttachmentComponentRef'
};

export const CSharpCallBackFunctions = {
  GetSearchDetailsByBarcode: 'GetSearchDetailsByBarcode',
  BarcodeReadCallBack: 'ReadBarcodefromCSharp',
  LoginResultCallBack: 'LoginResult',
  GetSiteCallBack: 'BindSites',
  SaveUserDeatilsCallBack: 'SaveUserDeatils',
  GetEatecGlobalSettingsCallBack: 'BindEatecGlobalSettings',
  GetSearchSourceCallBack: 'BindSearchSource',
  GetSearchValueCallBack: 'BindSearchValue',
  GetPackagesCallBack: 'BindPackages',
  GetInventoryCollectionDetailsCallBack: 'BindInventoryCollectionDetails',
  GetInventoryDetailsCallBack: 'BindInventoryDetails',
  RequisitionDetailsCallBack: 'BindRequisitionDetails',
  PhysicalDetailsCallBack: 'BindPhysicalDetails',
  GetLocationDetailsCallBack: 'BindLocationDetails',
  GetTransferAckPartsCallBack: 'BindTransferAckParts',
  GetRequisitionInventoryDetails: 'BindRequisitionInventoryDetials',
  UpdateRequisitionInventoryDetails: 'BindUpdatedRequisitionInventoryDetials',
  GetSearchDataCallBack: 'BindSearchData',
  GetRequisitionInventoryCollectionDetailsCallBack: 'BindRequisitionInventoryCollectionDetails',
  GetRequestLocationsCallBack: 'BindGetRequestLocations',
  GetReceivingLocationsCallBack: 'BindGetReceivingLocations',
  GetSupplyLocationsCallBack: 'BindGetSupplyLocations',
  GetCustomerLocationsCallBack: 'BindCustomerLocations',
  GetRequisitionPostCallBack: 'BindRequisitionPostResponce',
  GetPriorityCallBack: 'BindPriority',
  SaveRequisitonCallBack: 'BindRequisitionPostResponce',
  SavedRequisitionSummaryCallBack: 'BindSavedRequisitions',
  RedirectToSavedTransaction: 'RedirectToSavedTransaction',
  DeleteRequisiton: 'DeleteRequisitions',
  GetTransferDetailsCallBack: 'BindTransferDetails',
  GetDepartmentDetailsCallBack: 'BindDepartmentDetails',
  GetPayTermsDetailsCallBack: 'BindPayTermsDetails',
  GetAccountDetailsCallBack: 'BindAccountDetails',
  GetCustomerDetailsCallBack : 'BindCustomerDetails',
  GetMiscChargesCallBack : 'BindMiscCharges',
  GetTransferPostResponceCallBack: 'BindTransferPostResponce',
  GetSavedTransactionsCallBack: 'BindSavedTransactions',
  BindSavedOfflinePI: 'BindSavedOfflinePI',
  DeleteTransferCallBack: 'DeleteTransfer',
  DeleteTransactionCallBack: 'DeleteTransaction',
  GetSupplierDetailsCallBack: 'BindSupplierDetails',
  GetSystemPreferenceCallBack: 'BindSystemPreference',
  GetClosedFinancialPeriodDateCallBack: 'BindClosedFinancialPeriodDate',
  GetPoValuesCallBack: 'BindPoValues',
  GetPurchaseOrderResponseCallBack: 'BindPurchaseOrderResponse',
  GetPOSummaryCallBack: 'BindPOSummary',
  DeletePOCallBack: 'DeletePO',
  GetSpoilageInventoryDetailsCallBack: 'BindSpoilageInventoryDetails',
  GetSavedSpoilageDetailsCallBack: 'SavedSpoilageDetails',
  GetSavedReceivingDetailsCallBack: 'SavedReceivingDetails',
  GetSavedSpoilageCallBack: 'SavedSpoilage',
  GetreasonsCallBack: 'BindGetreasons',
  GetSpoilageInventoryDetialsCallBack: 'BindSpoilageInventoryDetials',
  GetSpoilagePostResponseCallBack: 'BindSpoilagePostResponse',
  DeleteSpoilageCallBack: 'DeleteSpoilage',
  DeletePI: 'DeleteOfflinePI',
  DeleteReceivingCallBack: 'DeleteReceiving',
  OfflineAllTransacationCallBack: 'SavedTransactions',
  OfflineSeletedSyncCallBack: 'SyncSeletecdResponse',
  OfflineBindPOCallBack: 'BindOfflinePO',
  OfflinePOAutoSaveCallBack: 'OfflineAutoSavePOCallBack',
  OfflineDeleteTransferCallBack: 'DeleteTransferResponse',
  OfflineBindTransferCallBack: 'BindOfflineTransfer',
  OfflineRequisitionCallBack: 'BindOfflineRequisition',
  BindBuildListCallBack: 'BindBuildList',
  BindBinList: 'BindBinList',
  BindLotList: 'BindLotList',
  BindBatchList: 'BindBatchList',
  PostTranscationCallBack: 'PostTranscation',
  BindLocationsCallBack: 'BindLocations',
  BindZonesCallBack: 'BindZoneData',
  BindBinCallBack: 'BindBinData',
  BindFinancialDateCallBack: 'BindFinancialDate',
  BindMasterDataSynctime: 'BindMasterDataSynctime',
  ClosePopUpMasterdataComplete: 'ClosePopUpMasterdataComplete',
  DeleteRequistionCallBack: 'DeleteRequistion',
  BindAboutAppCallBack: 'BindAboutAppData',
  UpdateAboutAppCallBack: 'UpdateApp',
  LoaderStopCallBack: 'LoaderStop',
  commonServiceComponentCallBack: 'BindPocketMenu',
  GetReceivingSupplierCallBack: 'BindGetReceivingSupplier',
  GetDeviceInformationCallBack: 'SaveDeviceInformation',
  OfflineBindExportResponse: 'BindOfflineExportRes',
  UserAccess : 'UserAccess',
  GetSiteLocationIds : 'GetSiteLocationIds',
  GetODataCollection: 'GetODataCollection',  
  BindSpoilagePostResponse: 'BindSpoilagePostResponse',
  BindInventoryLinkedItemDetails: 'BindInventoryLinkedItemDetails',
  BindApprovalLevel: 'BindApprovalLevel',
  BindSaveFile: 'BindSaveFile',
  GenerateReport: 'GenerateReport',
  BindPinExpiry:'BindPinExpiry',
  BindGetUserConfig: 'BindGetUserConfig',
  BindSavePin: 'BindSavePin',
  BindGetCurrencies: 'BindGetCurrencies',
  BindCapex: 'BindAllCapex',
  GetSearchByBinNumberCallBack: 'GetSearchByBinNumberCallBack',
  GetSearchByLotNumberCallBack: 'GetSearchByLotNumberCallBack',
  GetSearchByBatchNameCallBack: 'GetSearchByBatchNameCallBack',
  BindFacultyDetails: 'BindFacultyDetails',
  BindBatches: 'BindBatches'
};

export const LocalStorageGlobalSettings = 'GlobalSettings';

export const cSharpActionName = {
  GetSearchDetailsByBarcode: 'GetSearchDetailsByBarcode',
  SaveUserDetails: 'SaveUserDeatils',
  BindInstance: 'BindInstances',
  BindSites: 'BindSites',
  SyncMasterdata: 'SyncMasterdata',
  SyncSelectedTransationdata: 'SyncSelectedTransationdata',
  BindSearchSource: 'SearchSource',
  BindSearchvalue: 'SearchInventory',
  BindBinSearchvalue: 'GetInventoryDetailsForBin',
  BindTransferAckParts: 'GetTransferAckParts',
  BindInventoryDetails: 'Inventory',
  BindInventoryCollectionDetails: 'GetPackageListItems',
  BindRequisitionCollectionDetials: 'BindRequisitionCollectionDetials',
  BindSpoilageCollectionDetials: 'BindSpoilageCollectionDetials',
  BindPackages: 'GetPackages',
  BindClass: 'GetClass',
  BindTypes: 'GetTypes',
  BindSupplierItem: 'GetSupplierItem',
  BindStyleNumber: 'GetStyleNumber',
  BindRequisitionInventoryDetials: 'BindRequisitionInventoryDetials',
  BindSpoilageInventoryDetials: 'BindSpoilageInventoryDetials',
  PostTransactionDetails: 'CreateTransaction',
  BindPriority: 'GetPriority',
  BindGetRequestLocations: 'BindGetRequestLocations',
  BindGetSupplyLocations: 'BindGetSupplyLocations',
  GetLocationsByLocationType: 'GetLocationsByLocationType',
  GetAllZones: 'GetAllZones',
  GetAllBins: 'GetAllBins',
  BindGetreasons: 'BindGetreasons',
  BindCustomerLocations: 'GetCustomerLocation',
  BindCustomers: 'GetCustomers',
  GetFaculty: 'GetFaculty',
  BindGetMiscCharges: 'GetMiscCharges',
  BindTrancInventoryDetails: 'GetInventoryDetails',
  BindBinInventoryDetails: 'GetBinList',
  BindLotInventoryDetails: 'GetLotList',
  BindBatchInventoryDetails: 'GetBatchList',
  BindSavedRequisitions: 'SavedRequisitions',
  BindSavedOfflinePI: 'BindSavedOfflinePI',
  GetAllTransactions: 'GetAllTransactions',
  GetSavedDataToExport: 'GetSavedDataToExport',
  BindSavedRequisitionDetails: 'SaveRequisitionDetails',
  BindSavedPhysicalDetails: 'SavePhysicalDetails',
  UpdateRequisition: 'UpdateRequisition',
  BindDepartmentDetails: 'GetDepartmentDetails',
  BindPayTermsDetails: 'GetPayTermsDetails',
  BindAccountDetails: 'GetAccountDetails',
  GetFinancialDate: 'GetFinancialDate',
  BindSupplierDetails: 'GetSupplierDetails',
  GetLocationDetails: 'GetLocationDetails',
  GetLocation:'GetLocation',
  BindSystemPreference: 'GetSystemPreference',
  BindEatecGlobalSettings: 'GetEatecGlobalSettings',
  BindEatecMenus: 'GetEatecMenus',
  DeleteTransaction: 'DeleteTransaction',
  DeletePOTransaction: 'DeletePOTransaction',
  DeleteTransferTransaction: 'DeleteTransferTransaction',
  DeleteSpoilageTransaction: 'DeleteSpoilageTransaction',
  DeleteReceivingTransaction: 'DeleteReceivingTransaction',
  DeletePITransaction: 'DeletePITransaction',
  DeleteReqTransaction: 'DeleteReqTransaction',
  BindRequisitionTransactions: 'GetRequisitionTransactions',
  BindTransferTransactions: 'GetTransferTransactions',
  BindPurchaseorderTransactions: 'GetPurchaseordertransactions',
  BindSpoilageTransactions: 'GetSpoilageTransactions',
  BindReceivingTransactions: 'GetSavedReceiving',
  LoadSettings: 'LoadSettings',
  CheckTranscationIdExist: 'CheckTranscationIdExist',
  GetAboutApp: 'GetAboutApp',
  UpdateApp: 'UpdateApp',
  LoaderStop: 'LoaderStop',
  GetDeviceInfo: 'GetDeviceInfor',
  DeleteSpecificTransaction: 'DeleteSpecificTransaction',
  GetSiteLocationIds: 'GetSiteLocationIds',
  GetODataCollection: 'GetODataCollection',
  GetClosedFinancialPeriodDate : 'GetClosedFinancialPeriodDate',
  UpdateRGuestUser : 'UpdateRGuestUser',
  GetInventoryLinkedItemDetails : 'GetInventoryLinkedItemDetails',
  GetApprovalLevel : 'GetApprovalLevel',
  SaveFile:'SaveFile',
  GenerateReport: 'GenerateReport',
  GetUserConfig: 'GetUserConfig',
  GetCurrencies: 'GetCurrencies',
  GetAllCapex: 'GetAllCapex',
  BindSearchByBinItemNumber: 'SearchByBinItemNumber',
  BindSearchByLotItemNumber: 'SearchByLotItemNumber',
  SearchByBatchName: 'SearchByBatchName',
  GetSavedOfflinePI: "GetSavedOfflinePI",
  GetBatches: 'GetBatches',
};
export const IntercoUnAvailableModules = ['TransfersOut', 'Physical Inventory', 'Spoilage & Loss', 'Receiving'];
export const apiURLs = {
  TenantManagementApi: {
    GetTenant: '/tenantservice/api/Tenant', // Method Get, Pass expand TenantINIConfig and $filter TenantIdentifier PP
    GetUserFlow: '/tenantservice/api/TenantService/UserFlow'
  },
  UserManagementApi: {
    GetVerifiedUser: '/usermgmt/api/Login/verifyuser', // Method Post, Pass Tenant name in filter
    GetclientId: '/usermgmt/api/Login/getauthclientid', // Method Post, pass ClientId, RoleId, SiteId
    GetUserAccess: '/usermgmt/api/Login/useraccess', // Method Post, pass ClientId, RoleId, SiteId
    GetSystemConfig:'/tenantservice/api/TenantService/SystemConfiguration',
    GetToken: '/identity/api/Identity/token', // Method Post, pass ClientId, RoleId, SiteId
    EatecRefreshToken: '/identity/api/Identity/eatec/refreshtoken',
    GetUser: '/usermgmt/api/User', // Method Get
    GetSSo: '/usermgmt/api/Login/sso/mobile',
    GetSSoWeb: '/usermgmt/api/Login/sso',
    GeneratePin: '/usermgmt/api/GenerateMobilePin',
    GetPin: '/usermgmt/api/GetMobilePin',
    ValidateMobileLicense: '/usermgmt/api/Login/ValidateMobileLicense',
    UpdateMobileLogoutDetails: '/usermgmt/api/Login/UpdateMobileLogoutDetails',
    ForgotPassword: '/usermgmt/api/Login/forgotpassword',
    ChangePassword: '/usermgmt/api/Login/changepassword',
  },
  InvertoryManagement: {
    GetTransactionHeader: '/inventory/api/TransactionHeader/',
    GetInventoryLookup: '/inventory/api/IngredientLookup',
    GetInventoryLookupV2 : '/inventory/api/IngredientItemLookupV2',  // Method Post, InventoryLookUpPost entity
    GetAllBinUtilitiesByBinItemNumber: '/inventory/api/GetAllBinUtilitiesByBinItemNumber', // Method Post, Bin InventoryLookUpPost entity
    GetAllLotsByLotId: '/inventory/api/GetAllLotsByLotId',
    GetConsignmentItemLookup : '/inventory/api/ConsignmentItemLookup ',
    GetInventoryLocation: '/inventory/api/Locations', // Method Get, GetInventoryLocation entity
    GetRequisitionMasterData: '/inventory/api/GetRequisitionMasterData',
    GetTransferMasterData: '/inventory/api/GetTransferMasterData',
    GetPhysicalInventoryMasterData: '/inventory/api/GetPhysicalInventoryMasterData',
    GetPurchaseOrderMasterData: '/inventory/api/GetPurchaseOrderMasterData?fromMobile=true',
    GetReceivingMasterData: '/inventory/api/GetReceivingMasterData?fromMobile=true',
    GetSpoilageMasterData: '/inventory/api/GetSpoilageMasterData',
    GetPriority: '/inventory/api/Priorities',
    GetPackages: '/inventory/api/Packages?$filter=IsActive eq true and TypeId eq 1&$orderby=Name asc',
    GetPIIngLists: '/inventory/api/PIIngLists', // Method Post Get PhysicalInventoryPingList Data
    GetPhysicalInventoryLookup: '/inventory/api/PhysicalInventoryLookup',
    PostPhysicalHead: '/inventory/api/PhysicalHead', // Method Post PhysicalHead
    AutoSavePostPhysicalHead: '/inventory/api/PhysicalAutoSave',
    GetInventoryStatusByLocation: '/inventory/api/GetInventoryStatusByLocation',
    GetPackage: '/inventory/api/Packages',
    GetClasses: '/inventory/api/Classes',
    GetClassesTypesPackages: '/inventory/api/GetClassesTypesPackages',
    SearchBySupplierItemNumber: '/inventory/api/SearchBySupplierItemNumber',
    GetTypes: '/inventory/api/IngredientTypes',
    GetCustomer: '/inventory/api/Customer',
    GetDepartment: '/inventory/api/Departments',
    GetChartofAccount: '/inventory/api/GetChartAndSubChartOfAccounts',
    GetInventory: '/Inventory/api/Ingredients/',
    GetProduct: '/inventory/api/Products',
    GetIngredients: '/inventory/api/Ingredients',
    GetIngredientsBarcodes: '/inventory/api/IngredientsBarCodes',
    PostIngredientsBarcodes: '/inventory/api/IngredientsBarCodes',
    GetSavedPI:'/inventory/api/PhysicalHead',
    GetPhysicalById: '/inventory/api/GetPhysicalById',
    GetAllPhysicalInventory:'/inventory/api/GetAllPhysical',
    ReversePhysicalInventory: '/inventory/api/ReversePhysicalInventory',
    GetV2Customer:"/inventory/api/GetCustomers",
    FetchAllFaculties: "/inventory/api/FetchAllFaculties"
  },
  OdataInventoryManagementApi: {
    GetMetaData: '/inventory/api/$metadata',
  },
  RguestLoginUser: {
    GetLogin: 'https://v1-gateway-qaint.rguest.com/commongateway/Property/GetLoginDetails'
  },
  TransactionManagement: {
    GetRequisitionHead: '/inventory/api/ReqHead',
    GetItemTransactions: '/inventory/api/GetItemTransactions',
    // GetItemTransferList: '/inventory/api/ItemTransferList',
    GetItemTransferList: '/inventory/api/V1/ItemTransferListV1',
    GetAllRequisitions: '/inventory/api/GetAllRequisitions',
    GetTransGetSpoilageSummary: '/inventory/api/SpoilageHead',
    GetTransactionSpoilage: '/inventory/api/V1/GetIngredientUsageV1',
    GetAllSpoilage: '/inventory/api/GetAllSpoilage',
    GetPurchaseOrderHeadSummary: '/inventory/api/PurchaseOrderHead',
    GetPurchaseOrderById: '/inventory/api/GetPurchaseOrderById',
    GetSavedPOById: '/inventory/api/GetSavedPOById',
    DiscardSavedPO: '/inventory/api/DiscardSavedPO',
    GetPurchaseReqById: '/inventory/api/GetPurchaseReqById',
    GetAllPurchaseOrder: '/inventory/api/GetAllPurchaseOrder',
    GetAllSavedPO: '/inventory/api/GetAllSavedPO',
    GetPurchaseReqHead: '/inventory/api/PurchaseReqHead',
    GetAllPurchaseRequest: '/inventory/api/GetAllPurchaseRequest',
    GetSuppliersSearchDetails: '/inventory/api/Suppliers',
    GetPurchaseOrderDetail: '/inventory/api/Units',
    GetTransGetSpoilageDetails: '/inventory/api/SpoilageHead/117?transtype=11',
    GetTransferHead: '/inventory/api/TransferHead',
    GetAllTransfers: '/inventory/api/GetAllTransfers',
    PostPurchaseOrder: '/inventory/api/TransactionPurchaseOrder',
    AutoSavePostPurchaseOrder: '/inventory/api/POAutoSave',
    GetReceiving: '/inventory/api/ReceivingHead',
    GetReceivingDetailById: '/inventory/api/GetReceivingDetailById',
    GetAllReceiving: '/inventory/api/GetAllReceiving',
    CreateDocument: '/inventory/api/Integration/CreateDocument',
    RetrieveDocument: '/inventory/api/Integration/RetrieveAllDocument',
    DownloadDocument: '/inventory/api/Integration/RetrieveDocument',
    DeleteDocument: '/inventory/api/Integration/DeleteDocument',
    GetDMIntegrationConfiguration: '/inventory/api/DMIntegrationConfiguration?$filter=IsActive eq true',
    GetMiscCharges: '/inventory/api/MiscCharges?$filter=IsActive eq true',
    GetSearchHistory: '/inventory/api/SearchHistory',
    SaveSearchHistory: '/inventory/api/SaveSearchHistory',
    UnitType: '/inventory/api/UnitTypes?',
    ApprovalRequired: '/inventory/api/IsApprovalRequired',
    GetAllApprovers: '/inventory/api/GetAllApprovers',
    CheckDeliveryRule: '/inventory/api/CheckDeliveryCutOff',
    GetDetailsCount: '/inventory/api/DetailsCount',
    GetAllInTransitDelivery: '/inventory/api/GetAllInTransitDelivery',
    GetAllTransferAckParts: '/inventory/api/GetAllInTransitDelivery',
    GetInTransitData: '/inventory/api/GetInTransitData',
    SaveInTransit: '/inventory/api/SaveInTransit',
    GetIngredientConsignmentBatches: '/inventory/api/GetIngredientConsignmentBatches',
    GetConsignmentBatches: '/inventory/api/GetConsignmentBatches',
    GetAllOCRProcess: '/inventory/api/getallocrprocess',
    DownloadInvoice: '/inventory/api/downloadinvoice',
    UploadInvoice: '/inventory/api/uploadinvoice',
    GetERSInvoiceById: '/inventory/api/GetERSInvoiceById',
    SendMailToSupplier: '/inventory/api/GetPODetailsforResendEmail',
    GetApproversForReturn: "/inventory/api/GetApproversForReturn",
    GetDataForFilters: "/inventory/api/GetDataForFilters/"
  },
  Assets: {
    GetItemSource: '/assets/json/item-source.json'
  },
  GetUserLogin: '/api/Account/Login',
  GetToken: '/api/token',
  GetInstance: '/api/Account/Instances',
  GetSites: '/api/Account/Sites',
  GetCapexForTransaction: '/inventory/api/GetCapexForTransaction/',
  AccountAPI: /* Account API URLs */
  {
    GetToken: '/api/token',
    GetInstance: '/api/Account/Instances',
    GetSites: '/api/Account/Sites',
    GetLocationBySiteId: '/api/Account/LocationBySiteId',
    GetUserInformation: '/api/Account/UserInfo'
  },
  InventoryAPI: /* Inventory API URLs */
  {
    GetInventory: '/api/Inventory/Inventory',
    SearchInventory: '/api/Inventory/SearchInventory',
    GetInventoryStatusByLocation: '/api/Inventory/InventoryStatusByLocation',
    GetInventoryUsageStatus: '/api/Inventory/InventoryUsageStatus',
    GetInventoryPurchaseStatus: '/api/Inventory/InventoryPurchaseStatus',
    GetInventoryTypes: '/api/Inventory/InventoryTypes',
    GetInventoryClass: '/api/Inventory/InventoryClass',
    GetInventoryPackage: '/api/Inventory/InventoryPackage',
    GetInventoryCollectionDetails: '/api/Inventory/InventoryCollectionDetails',
    GetRecipeCollectionDetails: '/api/Inventory/RecipeCollectionDetails',
    GetProductCollectionDetails: '/api/Inventory/ProductCollectionDetails',
    GetInventoryZoom: '/api/Inventory/InventoryZoom',
    GetInventoryBidDetails: '/api/Inventory/InventoryBidDetails',
    GetInventorySummary: '/api/Inventory/InventorySummary',
    GetInventoryDetails: '/api/Inventory/InventoryDetail',
    GetInventoryBarcodeDetails: '/api/Inventory/InventoryBarcodeDetails',
    GetInventoryPurchaseOrders: '/api/Inventory/GetInventoryPurchaseOrders',
    GetInventoryLinkItems: '/api/Inventory/InventoryLinkItems',
    GetSuppliers: '/inventory/api/Suppliers',
    GetSites:'/inventory/api/Sites',
    GetV2Suppliers: '/inventory/api/v2/Getsuppliers',
    GetCurrencies: '/inventory/api/GetCurrencies',
    GetSupplierDetailForRecieving: '/inventory/api/GetSupplierDetailForRecieving'
    
  },
  MessageAPI: /* Message API URLs */
  {
    GetUserSites: '/api/Message/UserSites',
    GetMessages: '/inventory/api/GetAllMessages',
    PostMessages: '/api/Message/PostMessages',
    DeleteMessages: '/inventory/api/UpdateInboxMessage',
    UpdateMessages: '/inventory/api/UpdateInboxMessage'
  },
  PhysicalInventoryAPI: /* PhysicalInventory API URLs */
  {
    GetPhysicalForms: '/api/PhysicalInventory/PhysicalForms',
    GetProcessForm: '/api/PhysicalInventory/ProcessForm',
    GetBuildList: '/api/PhysicalInventory/BuildList',
    GetSavedPhysicalInventories: '/api/PhysicalInventory/LoadSavedPhysicalInventories',
    GetPhysicalInventory: '/api/PhysicalInventory/LoadPhysicalInventory',
    GetIsBuildAdjustment: '/api/PhysicalInventory/IsBuildAdjustment',
    GetPostAdjustment: '/api/PhysicalInventory/PostAdjustment',
    PostPhysicalInventory: '/api/PhysicalInventory/PostPhysicalInventory',
    SavePhysicalInventory: '/api/PhysicalInventory/SavePhysicalInventory',
    SaveAdjustments: '/api/PhysicalInventory/PostAdjustments',
    CancelPhysical: '/api/PhysicalInventory/CancelPhysical',
    PostFetchAllZones: '/inventory/api/FetchAllZones',
    PostGetAllBins: '/inventory/api/GetAllBins'
  },
  ProductAPI: /* Product API URLs */
  {
    SearchProducts: '/api/Product/SearchProducts',
    GetProductDetails: '/api/Product/ProductDetails'
  },
  PurchaseOrderAPI: /* Purchase Order API URLs */
  {
    GetMarketListItems: '/api/PurchaseOrder/MarketListItems',
    GetMarketLists: '/api/PurchaseOrder/MarketLists',
    GetPOSummary: '/api/PurchaseOrder/GetPOSummary',
    GetPODetail: '/api/PurchaseOrder/GetPODetail',
    GetApprovedRQASummary: '/api/PurchaseOrder/GetApprovedRQASummary',
    GetApprovedRQADetail: '/api/PurchaseOrder/GetApprovedRQADetail',
    SavePurchaseOrder: '/api/PurchaseOrder/PurchaseOrder',
    IsPOExist: '/api/PurchaseOrder/IsPOExist',
    GetPOExport: '/api/PurchaseOrder/GetPOExport'
  },
  RecipeAPI: /* Recipe API URLs */
  {
    GetRecipeDetails: '/api/Recipe/RecipeDetails',
    SearchRecipes: '/api/Recipe/SearchRecipes'
  },
  SalesAPI: /* Sales API URLs */
  {
    GetSalesSummary: '/api/Sales/SalesSummary',
    GetSalesDetails: '/api/Sales/SalesDetails',
    GetMediaDetails: '/api/Sales/MediaDetails',
    GetItemSales: '/api/Sales/ItemSales',
    SaveSales: '/api/Sales/Sales'
  },
  SetupAPI: /* Setup API URLs */
  {
    GetCustomer: '/api/Setup/Customer',
    GetLocations: '/api/Setup/Locations',
    GetSupplierDetails: '/api/Setup/SupplierDetails',
    GetUnitsDetails: '/api/Setup/UnitsDetails',
    SearchSuppliers: '/api/Setup/SearchSuppliers',
    IsApprovalRequired: '/api/Setup/IsApprovalRequired',
    GetDepartmentDetails: '/api/Setup/DepartmentDetails',
    GetAccountDetails: '/api/Setup/AccountDetails',
    GetReasons: '/api/Setup/GetReasons',
    GetSystemPrefrence: '/api/Setup/GetSystemPrefrence',
    GetSystemPrefrences: '/inventory/api/TransactionSystemPreferences',
    GetFinancialPeriodCloseDate: '/api/Setup/GetFinancialPeriodCloseDate',
    GetEatecGlobalSettings: '/api/Setup/GetEatecGlobalSettings',
    GetUserMenus: '/api/Setup/GetUserMenus',
    GetFinancialPeriods: '/inventory/api/FinancialPeriods'
  },
  RequisitionAPI: /* Requisition API URLs */
  {
    GetRequisitionSummary: '/api/Transaction/RequisitionSummary',
    GetRequisitionDetails: '/api/Transaction/RequisitionDetails',
    GetSuggestQuantities: '/api/Transaction/SuggestQuantities',
    SaveRequisition: '/api/Transaction/Requisition'
  },
  TransfersAPI: /* Transfers API URLs */
  {
    GetTransfersSummary: '/api/Transaction/TransfersSummary',
    GetTransfersDetails: '/api/Transaction/TransfersDetails',
    GetItemTransfer: '/api/Transaction/ItemTransfer',
    SaveTransfer: '/api/Transaction/Transfer'
  },
  InTransitAPI: /* InTransit API URLs */
  {
    GetTransactionHeader: '/inventory/api/TransactionHeader/'
  },
  SpoilageAPI: /* Spoilage API URLs */
  {
    GetSpoilageSummary: '/api/Transaction/SpoilageSummary',
    GetSpoilageDetails: '/api/Transaction/SpoilageDetails',
    SaveSpoilage: '/api/Transaction/Spoilage',
    GetSpoilageStatusSummary: '/inventory/api/TransactionHeader/',
    GetSpoilageReasonDetails: '/inventory/api/SpoilageReasons'
  },
  DocApprovalAPI: /* DocumentApprovals API URLs */
  {
    GetOpenOrders: '/api/Transaction/OpenOrders',
    GetTransactionApprovalHistory: '/api/Transaction/TransactionApprovalHistory',
    SaveProcessOrders: '/api/Transaction/ProcessOrders',
    GetApprovalTransactions: '/inventory/api/GetApprovalTransactions',
    ProcessApprovalTransactions: '/inventory/api/ProcessApprovalTransactions'
  },
  TransactionAPI: /* Transaction API URLs */
  {
    GetTransactionStatusSummary: '/api/Transaction/TransactionStatusSummary',
    LockUnlockTransaction: '/api/Transaction/LockUnlockTransaction',
    CancelTransactions: '/api/Transaction/CancelTransactions',
    ReverseTransaction: '/api/Transaction/ReverseTransaction',
    GetSearchHistory: '/api/Transaction/GetSearchHistory',
    GetSearchSource: '/api/Transaction/GetSearchSource',
    SaveSearchHistory: '/api/Inventory/SaveSearchHistory',
    SearchHistory: '/api/Inventory/SearchHistory',
    GetPriority: '/api/Transaction/Priority',
  },
  HealthCheckAPI: {
    ConnectionStatus: '/api/Connection/ConnectionStatus',
    HealthCheckTime: '/api/Connection/HealthCheckupTime'
  },
  LicencingAPI: {
    GetLoggedInUserDetails: '/usermgmt/api/Login/GetDeviceList',
    GetLicenceStatusSummary: '/api/Licensing/GetLicensingSummary',
    SaveUserDeviceInformaion: '/api/Licensing/SaveUserDeviceInfo',
    PostSuspendUser: '/usermgmt/api/Login/SuspendUser',
    SendMail: '/api/Licensing/SendMail'
  }
};

/* Local storage */
export const LoggedInClientId = 'ClientId';
export const userSessionName = 'currentUser';
export const instanceName = 'instanceName';
export const userInfo = 'UserInfo';
export const loggedInSiteId = 'loggedInSiteId';
export const loggedInLocationId = 'loggedInLocationId';
export const loggedInSiteName = 'loggedInSiteName';
export const loggedInSiteFullName = 'loggedInSiteFullName';
export const loggedInDecimalViewValue = 'loggedInDecimalViewValue';
export const loggedInCurrencyViewValue = 'loggedInCurrencyViewValue';
export const loggedInSiteAbbreviation = 'loggedInSiteAbbreviation';
export const loggedInUserId = 'loggedInUserId';
export const IsConcurrentLoginIniConfigPresent = 'IsConcurrentLoginIniConfigPresent';
export const loggedInUserName = 'loggedInUserName';
export const UserInfo = 'UserInfo';
export const UserName = 'UserName';
export const loggedInUserlanguage = 'lang';
export const ReceivingLocation = 'ReceivingLocation';
export const CurrencyCode = 'CurrencyCode';
export const decimalFormat = 'decimalFormat';
export const currencyFormate = 'currencyFormate';
export const dateFormate = 'dateFormate';
export const ReceivingSupplierList = 'ReceivingSupplierList';
export const userPrivileges = 'userPrivileges';
export const DeviceId = 'DeviceId';
export const DeviceName = 'DeviceName';
export const DeviceType = 'DeviceType';
export const HasCamera = 'HasCamera';
export const IsRguest = 'IsRguest';
export const RguestLoginURL = 'RguestLoginURL';
export const RGuestProductId = 'RGuestProductId';
export const RGuestTenantCode = 'RGuestTenantCode';
export const RGuestTenantId = 'RGuestTenantId';
export const IntegrationConfig = 'IntegrationConfig'
export const IsAD = 'IsAD';
export const InventoryLookUpTake = 100;
export const GetCallTake = 25;
export const BinEnable = 'BinEnable';
export const LanguageJson = 'LanguageJson';
export const SelectedLanguage = 'SelectedLanguage';
export const DefaultLanguage = 'en-US';
export const ShowLanguage = 'showLanguage';
export const CurrentVersion = 'CurrentVersion'
export const TimeZone = 'TimeZone';
export const UserTimeZone = 'UserTimeZone';
export const TimezoneDescription = 'TimezoneDescription';

export const ODataCollection = 'ODataCollection';
/** Default idle seconds for default session index (24 h): (1440 * 60) - 60 */
export const Default_SessionInactivityTime = '86340';
/** Max index into `sessionData` (short presets 0–11 + longer presets 12–15). */
export const SessionPresetMaxIndex = 15;
/** Default preset index: 24 hours. */
export const DefaultSessionPresetIndex = '15';
/** Wall-clock expiry for access token (unix seconds), persisted for proactive refresh. */
export const AccessTokenExpiresAtUnix = 'AccessTokenExpiresAtUnix';
/** Server session Guid string for eatec/refreshtoken body. */
export const EatecSessionId = 'eatecSessionId';
// export const TimeZoneDateTimeFormat = 'MM/DD/YYYY hh:mm:ss z(Z)';
export const TimeZoneDateTimeFormat = 'MM/DD/YYYY hh:mm:ss A';
export const DefaultDateFormat = 'MM/DD/YYYY';
export const PostDateTimeFormat = 'YYYY-MM-DDTHH:mm:ss';
export const PostUTCDateTimeFormat = 'YYYY-MM-DDTHH:mm:ssZ';
// export const DefaultTimeZone = 'Pacific/Apia';
// export const DefaultUserTimeZone = 'Eastern Standard Time';
export const DefaultTimeZone = moment.tz.guess();
const LocalUserTimeZone = moment().toDate()?.toString()?.split("(")[1]?.split(")")[0];
export const DefaultUserTimeZone = LocalUserTimeZone?.length ? LocalUserTimeZone[0] : '';

// **Rguest* */
export const RguestTenantCode = 'Eatwell';
export const RguestProductId = 8;

/* Http request headers */
export const reqHeaderJson = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
export const reqHeaderURLEncode = new HttpHeaders(
  {
    'Content-Type': 'application/x-www-form-urlencoded',
    'No-Auth': 'True',
    'odata-version': '4.0',
    'Accept': 'application/json',
    'server': 'Kestrel'
  });

export const reqHeaderURLEncodes = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'Auth': 'True' });

export const reqHeaderURLParams = new HttpHeaders({ 'Content-Type': 'application/json' });

export const NUMBER_VALUES: any = {
  'one': 1,
  'two': 2,
  'three': 3,
  'four': 4,
  'five': 5,
  'six': 6
};

export const URL: any = {
  'getrevenue': '/getrevenue'
};

// *****Pop Up Config************//
export const popupConfig: any = {
  // "popupheight": 270,
  'popupwidth': '280',
  'panelClass': 'dialog-containers',
  'maxWidth': '90vw'
};

export const LocalJson: any = {
  'inventoryList': '/inventory-list.json',
  'inventorydetails': '/inventory-details.json',
  'inventoryTile': '/inventory-tile.json',
  'purchaseTile': '/inventory-tile.json',
  'location': '/location.json',
  'suppliers': '/suppliers.json',
  'requisitionList': '/requisition-list.json',
  'requisitions': '/requisitions.json',
  'purchase': '/poDetails.json',
  'optionArray': '/inventory-search.json',
  'allRequisitions': '/all-requisitions.json',
  'allPO': '/all-po.json',
  'POLoadReq': '/all-po.json',
  'POApprovedReq': '/all-po.json',
  'requisitionDetails': '/requisition-details.json',
  'purchaseDetails': '/poDetails.json',
  'packageListItems': '/package-items.json',
  'getrecentItems': '/recently-item.json',
  'getTransferDetails': '/transfer-details.json',
  'packageItems': '/package-items.json',
  'menuItems': '/menu-list.json',
  'spoilages': '/all-spoilages.json',
  'transfers': '/all-requisitions.json',
  'purchaseorder': '/poDetails.json',
  'linkedItems': '/linked-items.json',
  'barCode': '/barcode.json',
  'messages': '/messages.json',
  'locations': '/location.json',
  'documentApproval': '/document-approval.json',
  'physicalInventoryItems': '/physical-inventory-items.json',
  'saveMessages': '/saved-message.json'
};
export const linkedItemSource: any = [{ 'id': 0, 'name': 'Products' }, { 'id': 1, 'name': 'Packages' }];
export const MENUARRAY: any = [
  {
    'id': 1,
    'headername': 'Dashboard',
    'router': '/dashboard',
    'routerLinkActive': 'active-link',
    'subheader': [],
  },
  {
    'id': 2,
    'headername': 'Inventory',
    'router': '',
    'routerLinkActive': 'active-link',
    'subheader': [
      {
        'id': 1,
        'headername': 'Inventory List',
        'router': '',
        'routerLinkActive': 'active-link',
      },
      {
        'id': 2,
        'headername': 'Inventory List',
        'router': '',
        'routerLinkActive': 'active-link',
      },
      {
        'id': 3,
        'headername': 'Requistaion',
        'router': '',
        'routerLinkActive': 'active-link',
      },
      {
        'id': 4,
        'headername': 'Requistaion',
        'router': '',
        'routerLinkActive': 'active-link',
      },
      {
        'id': 5,
        'headername': 'Transfers',
        'router': '',
        'routerLinkActive': 'active-link',
      },
      {
        'id': 6,
        'headername': 'Purchase Order',
        'router': '',
        'routerLinkActive': 'active-link',
      },
      {
        'id': 7,
        'headername': 'Merchandise Arrival',
        'router': '',
        'routerLinkActive': 'active-link',
      }
    ],
  },
  {
    'id': 3,
    'headername': 'Physical Inventory',
    'router': '',
    'routerLinkActive': 'active-link',
    'subheader': [],
  },
  {
    'id': 4,
    'headername': 'Reports',
    'router': '',
    'routerLinkActive': 'active-link',
    'subheader': [],
  },
  {
    'id': 5,
    'headername': 'Setting',
    'router': '',
    'routerLinkActive': 'active-link',
    'subheader': [],
  }

];


export enum InventoryTypeList {
  Inventory = 1,
  Recipe = 2,
  Product = 3
}
export enum PackageType {
  Inventory = 1,
  Receipe = 2,
  Equipment = 3,
  Customer = 5,
  Supplier = 6,
  Product = 7
}

export enum InventoryCollectionType {
  Type = 0,
  Class = 1,
  Package = 2
}

export enum Actions {
  EnterQuantitiesManually = 1,
  SetItemsToZero = 2,
  SetItemsToLastCount = 3
}

export enum ActionNames {
  EnterQuantitiesManually = "Enter Quantities Manually",
  SetItemsToZero = "Set Items To Zero",
  SetItemsToLastCount = 'Set Items To Last Count'
}

export enum GroupBySource {
  None = 1,
  All = 2,
  Requisition = 1,
  Spoilage = 4,
  Transfer = 5,
  Purchasing = 6,
  RQA = 7,
}
/**
 * @version UI 13.2
 * @method TranGroupSource
 */
export enum TranGroupSource {
  Requisition = 1,
  ReqLoadFromTrans = 2,
  Transfer = 3,
  TransLoadFromTrans = 4,
  Spoilage = 5,
  PurchaseRequest = 6,
  PurchaseOrder = 7,
  All = 8
}

export enum UnitType {
  BaseUnit = 1,
  PurchaseUnit = 2,
  TransactionUnit = 3,
  RecipeUnit = 4,
  BatchSizeUnit = 5,
  PortionsUnit = 6,
  SalesUnit = 2
}
export enum Formater {
  DecimarFormater = 0,
  OquantityFormater = 2
}

export enum LocationType {

  SupplyLocation = 0,
  RequisitionLocation = 1,
  TransferLocation = 2,
  AllLocation = 3,
  Receiving = 4,
  Physical = 5,
  TransferFrom = 6

}
export enum TransactionType {
  All = 0,
  PurchaseRequest = 1,
  Transfer = 5,
  Requisition = 4,
  Spoilage = 11,
  Physical = 13,
  TransferOut = 6,
  TransferByInventory = 6,
  PurchaseRequestRQA = 7,
  PurchaseOrder = 2,
  RequisitionByInventory = 9,
  Receiving = 3,
  GenericRequisition = 20,
  InvoiceAutomation = 42
}
/**
 * @version 13.2 UI
 * @description change TransactionType enum
 * @enum TransType
*/
export enum TransType {
  All = 0,
  Transfer = 5,
  Requisition = 4,
  Spoilage = 11,
  Physical = 13,
  TransferOut = 6,
  TransferByInventory = 6,
  PurchaseRequestRQA = 7,
  PurchaseOrder = 2,
  SavedPurchaseOrder = 46,
  RequisitionByInventory = 9,
  Receiving = 3,
  GenericRequisition = 20,
}

/**
 * @version 24.2 UI
 * @description change TransactionType enum
 * @enum TransTypeId
*/
export enum TransTypeId {
  All = 0,
  Requisition = 5,
  Transfer = 4,
  Spoilage = 11,
  Physical = 13,
  TransferOut = 6,
  TransferByInventory = 6,
  PurchaseRequestRQA = 7,
  PurchaseOrder = 2,
  RequisitionByInventory = 9,
  Receiving = 3,
  GenericRequisition = 20,
}

/**
 * @version UI-13.2
 */

export enum TransactionStatus {
  OpenTransaction = 1,
  CancelledTransaction = 2,
  CompletedTranasaction = 3,
  PartialTransaction = 4
}

export enum RequisitionMenus {
  LoadToAddNew = 1,
  OpenRequisitions = 2,
  LoadFromTransactions = 3,
  LoadFromTemplate = 4,
  CancelRequisitions = 5,
  SuggestQuantities = 6,
  UnlockAllLockedRequisitions = 7,
  UnlockThisRequisition = 8,
  UnlockAllLockedRequisitionsRQA = 9,
  UnlockThisRequisitionRQA = 10
}

export enum TransferMenus {
  TransInLoadFromTransactions = 1,
  TransOutLoadFromTransactions = 2,
  TransInOpenRequisitions = 3,
  TransOutOpenRequisitions = 4,
  TransInReverseTransfer = 5,
  TransOutReverseTransfer = 6
}

export enum InventoryMenus {
  LoadRequisitionsFromInventory = 1,
  LoadRequisitionsFromRetailInventory = 2,
  LoadTransfersFromInventory = 3
}
export enum SpoilageMenus {
  LoadFromTransactions = 1,
  PendingApprovals = 2
}

export enum PurchaseOrderMenus {
  LoadRequisitions = 1,
  LoadApprovedRQA = 2,
  LoadAllPO = 3,
}

export const SearchSourceType = {
  SearchByClass: 'Class',
  SearchByInventory: 'Inventory',
  SearchByPackage: 'Package',
  SearchByPurchase: 'Purchase',
  SearchByRecipe: 'Recipe',
  SearchByRequisition: 'Requisition',
  SearchBySales: 'Sales',
  SearchBySpoilage: 'Spoilage',
  SearchByTransfer: 'Transfer',
  SearchByType: 'Type',
  SearchBySupplierItem: 'Supp. Item #',
  SearchByStyleNumberItem: 'Style Number'
};

export enum SourceType {
  All = 0,
  MerchArrival = 1,
  Transfers = 2,
  SpoilLoss = 3,
  RestSales = 21,
  Requisition = 51,
  PurchaseRequest = 52,
  PurchaseOrder = 54,
  TransDepletion = 62,
  RNI = 71
}

export enum TransactionLockType {
  UnLock = 0,
  Lock = 1,
  UnLockAll = 2
}

export enum InventoryLinkTypes {
  Products = 0,
  Packages = 1
}

export enum LocationDBType {
  None = 1,
  AllPurpose = 2,
  Inventorynly = 3,
  SalesOnly = 4,
  Concession = 5,
  NoInventory = 6,
  Catering = 7,
  TransfersOut = 8,
  IntersiteSupply = 9,
  InTransit = 10,
  DirectExpense = 11
}

export enum LocationTypes {
  None = 1,
  AllPurpose = 2,
  Inventorynly = 3,
  SalesOnly = 4,
  Concession = 5,
  NoInventory = 6,
  Catering = 7,
  TransfersOut = 8,
  IntersiteSupply = 8,
  InTransit = 10,
  DirectExpense = 11
}

export enum ReversalType {
  SalesReversal = 1,
  MAReversal = 2,
  TransferReversal = 3,
  SpoilageReversal = 4,
  RNIReversal = 5,
  TransferOutReversal = 6
}

export enum SendVia {
  'None' = 0,
  'E-Mail' = 1,
  'Fax' = 2,
  'Mail' = 3,
}
export enum MessageFunction {
  '[None]' = 0,
  'Stock Take' = 100000,
  Purchasing = 190000,
  Production = 150000,
  Transfer = 120000

}
export enum MessageStatus {

  Unread = 0,
  Read = 1,
  Draft = 2

}
export enum POInventoryLoadPrioroity {
  ByCurrentSiteLocationDefinition = 0,
  ByLastPurchase = 1,
  ByAutoAssignBidPOMA = 2,
  ByLastPurchaseAndAutoAssignBidPOMA = 3
}
export enum RealTimeDepletion {
  No = 0,
  YesCumulative = 1,
  YesNonCumulative = 2
}
export enum PriceOrder {
  NormalProductPrice = 0,
  ByDateRange = 1,
  ByDateLocation = 2,
  ByDateCustomer = 3,
  ByDateLocationCustomer = 4,
  ByLocationCustomer = 5,
  ByLocation = 6
}
export enum ConcessionBehaviour {
  No = 0,
  Concession = 1,
  ConcessionWithStandardSheets = 2
}
export enum SupplierTotal {
  SupplierTotalOptional = 0,
  MustEnterASupplierTotalInMA = 1,
  MustReconcileWithSupplierTotalInMA = 2
}
export enum POMAItemDataLoadType {
  CurrentSiteLocation = 0,
  LastPurchase = 1,
  AutoAssignBidPOMA = 2,
  LastPurchaseWithAutoAssignBid = 3
}
export enum RQAItemDataLoadType {
  CurrentSiteLocation = 0,
  LastPurchase = 1,
  AutoAssignBid = 2,
  LastPurchaseWithAutoAssignBid = 3
}
export enum WarningOnCostChange {
  NoWaringForCostChange = 0,
  WarnIfCostIsOverPredefinedPercentInType = 1
}
export enum POAddEndNums {
  Allowed = 0,
  NotAllowed = 1
}
export enum BackOrderType {
  NoBackOrderByType = 0,
  AllowBackOrderByType = 1,
  BackOrderByItem = 1
}
export enum TaxReceivingOption {
  AddToInventory = 0,
  AssignToMiscItem = 1
}
export enum EnforceRetailStyle {
  No = 0,
  Warn = 1,
  Prevent = 2
}
export enum POMABidPriceUpdate {
  No = 0,
  UpdateBidsFromPO = 1,
  UpdateBidsFromMA = 2
}
export enum LocationTypes {
  ReqFromLocationType = '9,3,2,5,1,6,8,11',
  ReceivingLocationType = '9,3,2,5,1,11',
  RegToLocType = '9,3,2,5,1',
  TransferFromLocationType = '9,3,2,5,1',
  InTransitLocationType = '10',
  TransferToLocationType = '11,2,3,9,6,5,1,8',
  RequisitionTransferToLocationType = '11,2,3,9,10,6,5,1,8',
  TransferOutToLocationType = '8',
  TransferInLocationType = '11,2,3,9,6,5,1',
  RequisitionTransferInLocationType = '11,2,3,9,10,6,5,1',
  SpoilageLocType = '9,3,2,5,1',
  PurchaseOrder = '1,2,3,5,9,11',
  PILocationType = '1,2,3,5,9'
}
export enum OrderPeriod {
  NoDefault = 0,
  OneWeek = 1,
  TwoWeek = 2,
  ThreeWeek = 3,
  FourWeek = 4,
  FiveWeek = 5,
  SixWeek = 6
}
export enum PreventExpiredLots {
  No = 0,
  Yes = 1
}
export enum SeparateApprovalRequired {
  No = 0,
  Yes = 1
}
export enum RetailDescriptor {
  No = 0,
  DescOne = 1,
  DescTwo = 2,
  DescThree = 3,
  DescFour = 4,
  DescFive = 5,
  DescSix = 6
}
export enum AutoSaveInterval {
  No = 0,
  ThirtySecondInterval = 1,
  SixtySecondInterval = 2,
  FiveMinuteInterval = 3,
  TenMinuteInterval = 4
}
export enum SearchLookUpKey {
  Name = 0,
  Number = 1,
  Description = 2,
  Barcode = 3
}
export enum TransFilterPeriod {
  NoFilter = 0,
  TwoWeeks = 1,
  FourWeeks = 2,
  SixWeeks = 3,
  EightWeeks = 4,
  TenWeeks = 5
}
export enum TransSortBy {
  Number = 0,
  Name = 1,
  Abbrevation = 2
}
export enum ReqBackOrder {
  NoBackOrder = 0,
  RequisitionBackOrderEnabled = 1,
  CreateNewReqWithBalance = 2
}
export enum MessageExpirationPeriod {
  NoFilter = 0,
  TwoWeeks = 1,
  FourWeeks = 2,
  SixWeeks = 3,
  EightWeeks = 4,
  TenWeeks = 5
}
export enum AuditLoggingLevel {
  None = 0,
  LoginLogOut = 1,
  TransactionPosting = 2,
  Access = 3,
  ScreenVisit = 4,
  MenuSelect = 5
}
export enum StartingEvent {
  Nothing = 0,
  ReplenishToPar = 1,
  PostOpenRequest = 2
}
export enum SequentialNumbers {
  None = 0,
  Type = 1,
  SubType2 = 2,
  Class = 3
}
export enum RecipeCalculationMethod {
  ApplicationCode = 0,
  UseDataBaseObjects = 1
}
export enum AutoScanInterval {
  No = 0,
  ThirtySecondInterval = 1,
  SixtySecondInterval = 2,
  FiveMinuteInterval = 3,
  TenMinuteInterval = 4
}
export enum TraceLevel {
  Error = 0,
  Warning = 1,
  Information = 2,
  ExchangeTrace = 3,
  EatecServerTrace = 4
}
export enum DepletionSubstituteActivity {
  NotActive = 0,
  TakeTimeToZero = 1,
  DepleteBalanceFromSubstitute = 2,
  DepleteSubstituteOnly = 3
}
export enum ReqLevelFilter {
  All = 0,
  UserApprovalLevelOnly = 1,
  UserLevelAndBelow = 2,
  OneBelowUsersLevelAndAbove = 3
}
export enum NegativeTransfers {
  DoNotAllow = 0,
  AllowWithRemarks = 1,
  AllowAll = 2
}


export const messageFunction = [
  { id: 0, value: '[None]' },
  { id: 100000, value: 'Physical Inventory' },
  { id: 190000, value: 'Purchase Order' },
  { id: 150000, value: 'Production' },
  { id: 120000, value: 'Transfer' }


];

export const dataFilterOptions = [
  { id: 0, value: '1 Week (Default)' },
  { id: 1, value: '2 Weeks' },
  { id: 2, value: '4 Weeks' },
  { id: 3, value: '6 Weeks' },
  { id: 4, value: '8 Weeks' },
  { id: 5, value: '10 Weeks' }
];

/** Idle duration presets: `data` is minutes (same shape as historical session list). */
export const sessionData = [
  { id: 0, value: '5 minutes', data: 5 },
  { id: 1, value: '10 minutes', data: 10 },
  { id: 2, value: '15 minutes', data: 15 },
  { id: 3, value: '30 minutes', data: 30 },
  { id: 4, value: '1 hour', data: 60 },
  { id: 5, value: '2 hours', data: 120 },
  { id: 6, value: '3 hours', data: 180 },
  { id: 7, value: '4 hours', data: 240 },
  { id: 8, value: '5 hours', data: 300 },
  { id: 9, value: '6 hours', data: 360 },
  { id: 10, value: '7 hours', data: 420 },
  { id: 11, value: '8 hours', data: 480 },
  { id: 12, value: '12 hours', data: 720 },
  { id: 13, value: '16 hours', data: 960 },
  { id: 14, value: '20 hours', data: 1200 },
  { id: 15, value: '24 hours (default)', data: 1440 }
];

/**
 * Normalizes `session`, `idleTimeout`, and `sessionToggle` in localStorage:
 * - Missing/empty/invalid `session` → default preset (24h, index {@link DefaultSessionPresetIndex}).
 * - Legacy idle disabled (`sessionToggle` === `'false'` or `idleTimeout` === `'0'`) → same 24h default and toggle `'true'`.
 * - Valid preset with idle already enabled → unchanged.
 */
export function normalizeLegacySessionIndex(): void {
  const raw = localStorage.getItem('session');
  const sessionStr = raw == null ? '' : String(raw).trim();
  const n = sessionStr !== '' ? parseInt(sessionStr, 10) : NaN;
  const sessionValid = Number.isFinite(n) && n >= 0 && n <= SessionPresetMaxIndex;

  const toggle = localStorage.getItem('sessionToggle');
  const idleRaw = localStorage.getItem('idleTimeout');
  const idleNum =
    idleRaw != null && String(idleRaw).trim() !== '' ? parseInt(String(idleRaw), 10) : NaN;
  const legacyIdleDisabled =
    toggle === 'false' ||
    idleRaw === '0' ||
    (Number.isFinite(idleNum) && idleNum === 0);

  const noSessionValue =
    raw == null ||
    sessionStr === '' ||
    sessionStr === 'undefined' ||
    sessionStr === 'null' ||
    !sessionValid;

  if (legacyIdleDisabled || noSessionValue) {
    const idx = parseInt(DefaultSessionPresetIndex, 10);
    const secs = sessionPresetIndexToIdleSeconds(idx);
    localStorage.setItem('session', DefaultSessionPresetIndex);
    localStorage.setItem('sessionToggle', 'true');
    localStorage.setItem('idleTimeout', String(secs));
  }
}

/**
 * Resolves session preset index (0..{@link SessionPresetMaxIndex}) for storage and idle seconds.
 * Pass a settings form value (including `0`); omit or pass `undefined` to use `localStorage.session` only.
 */
export function resolveSessionPresetIndex(formSession?: unknown): number {
  const defaultIdx = parseInt(DefaultSessionPresetIndex, 10);
  const useForm =
    formSession !== undefined &&
    formSession !== null &&
    !(typeof formSession === 'string' && formSession.trim() === '');
  const raw = useForm ? formSession : localStorage.getItem('session');
  const sessionStr = raw == null ? '' : String(raw).trim();
  if (sessionStr === '' || sessionStr === 'undefined' || sessionStr === 'null') {
    return defaultIdx;
  }
  const n = parseInt(sessionStr, 10);
  if (!Number.isFinite(n) || n < 0 || n > SessionPresetMaxIndex) {
    return defaultIdx;
  }
  return n;
}

/** Idle seconds for ng-idle: one minute before chosen duration ends (matches existing app behavior). */
export function sessionPresetIndexToIdleSeconds(index: number): number {
  const row = sessionData[index];
  if (!row) {
    return JSON.parse(Default_SessionInactivityTime) as number;
  }
  return row.data * 60 - 60;
}

export const imagesUrl = {
  loginBackground: 'assets/images/LoginImage.png'
};

export enum readMore {
  fontColor = '#FF5A5E',
  fontFamily = 'Roboto-Regular',
  fontSize = '10px'

}
export enum userGroup {
  Admin = 5
}
export enum previlgeModule {
  Inventory = 'Inventory',
  Requisition = 'Requisition',
  TransactionManagement = 'transactionsmanagement',
  MasterManagement = 'mastermanagement',
  PhysicalInventory = 'Physical Inventory',
  PurchaseOrder = 'purchaseorder',
  SpoilageLoss = 'Spoilage & Loss',
  Transfers = 'Transfers',
  Reports = 'Reports',
  Receiving = 'Receiving',
  PurchaseRequest = 'Purchase Request',
  Messages = 'Messages',
  ChangeOrders = 'Change Orders',
  PendingApprovals = 'Pending Approvals',
  Retail = 'Retail',
  TransfersOut = 'TransfersOut'
}

export enum PREVILEGEKEY {
  GetInventoryStatusbyLocation = 'GetInventoryStatusByLocation',
  GetPurchasesItemList = 'GetPurchasesItemList',
  GetItemTransfer = 'GetItemTransfer',
  GetInventoryUsageStatus = 'GetInventoryUsageStatus',
  PostTransfer = 'PostTransferStd',
  PostReverseTransactions = 'ReverseTransferandTransferOut',
  GetTransfersSummary = 'GetTransfersSummary',
  GetRequisitionSummary = 'GetRequisitionSummary',
  GetApprovedRQASummary = 'CreatePurchaseRequests',
  GetTransferDetails = 'GetTransferDetails',
  UnknownApiKey = 'UnknownApiKey',
  TransferAck = 'AcknowledgementTransfer',
  GetTransactionStatusSummary = 'GetTransactionStatusSummary',
  GetInventoryList = 'GetInventoryList',
  GetInventoryDetails = 'GetInventoryDetails',
  GetInventoryLinkItems = 'GetInventoryLinkItems',
  GetInventoryHistory = 'GetInventoryHistory',
  GetPrintDocument = 'GetPrintDocument',
  GetInventoryBidDetails = 'GetInventoryBidDetails',
  GetInventoryBarcodeDetails = 'GetInventoryBarcodeDetails',
  GetInventoryPurchaseOrders = 'GetInventoryPurchaseOrders',
  GetSuggestQuantities = 'GetSuggestQuantities',
  GetInventoryDetails_AS = 'GetInventoryDetails_AS',
  GetInventoryDetails_OF = 'GetInventoryDetails_OF',
  PostRequisition = 'PostTransferStd',
  PostMa = 'PostMa',
  SaveMa = 'SaveMa',
  CancelTransactions = 'CancelTransactions',
  GetInventoryDetails_PreviousRecord = 'GetInventoryDetails_PreviousRecord',
  GetInventoryDetails_NextRecord = 'GetInventoryDetails_NextRecord',
  LoadSavedPhysicalInventories = 'LoadSavedPhysicalInventories',
  SavePhysicalInventory = 'SavePhysicalInventory',
  ProcessForm = 'ProcessForm',
  BuildList = 'BuildList',
  IsBuildAdjustment = 'IsBuildAdjustment',
  PostAdjustment = 'PostAdjustment',
  GetPostAdjustment = 'GetPostAdjustment',
  PostPhysicalInventory = 'PostPhysicalInventory',
  PostCancelPhysical = 'CancelPhysical',
  GetPrintOptions = 'GetPrintOptions',
  GetSearchFilter = 'GetSearchFilter',
  PostPurchaseorder = 'PostPurchaseorder',
  GetRequisitionSummary_Req = 'GetRequisitionSummary_Req',
  GetRequisitionSummary_All = 'GetRequisitionSummary_All',
  GetCreateRequistion = 'CreateRequisition',
  GetCancelRequisition = 'CancelRequisition',
  CancelTransactions_Single = 'CancelTransactions_Single',
  CancelTransactions_Batch = 'CancelTransactions_Batch',
  DeleteSavedPO = 'DeleteSavedPO',
  CancelPurchaseOrder = 'CancelPO',
  GenerateReports = 'GenerateReports',
  ReportsMyReports = 'GetReports_MyReports',
  SaveScheduledReports = 'SaveScheduledReports',
  GetScheduledReports = 'GetScheduledReports',
  DeleteScheduledReports = 'DeleteScheduledReports',
  PostSpoilage = 'PostSpoilageStd',
  GetSpoilageSummary = 'GetSpoilageSummary',
  GetPOSummary = 'GetPOSummary',
  POProcessingOptions = 'POProcessingOptions',
  GetAssignBids = 'AssignBids',
  GetLoadOrderGuide = 'LoadOrderGuide',
  GetInvoice = 'GetInvoice',
  GetSavedInvoice = 'GetSavedInvoice',
  GetCreateReceiving = 'CreateReceiving',
  GetInvoiceDetails = 'GetInvoiceDetails',
  GetSavedInvoiceDetails = 'GetSavedInvoiceDetails',
  DeleteSavedInvoice = 'DeleteSavedInvoice',
  GetPictureVideos = 'GetPictureVideos',
  DeletePictureVideos = 'DeletePictureVideos',
  AccountingSummary = 'AccountingSummary',
  LoadOrderGuide = 'LoadOrderGuide',
  GetTransactionApprovalHistory = 'GetTransactionApprovalHistory',
  GetRequestsSummary_All = 'GetRequestsSummary_All',
  GetRequestsSummary_Open = 'GetRequestsSummary_Open',
  PostPurchaseRequest = 'PostTransferStd',
  PR_CancelTransactions_Batch = 'CancelTransactions',
  GetOpenOrders = 'GetOrders',
  PRApprovalHistory = 'GetTransactionApprovalHistory',
  PRGetAssignBids = 'AssignBids',
  PRGetPictureVideos = 'GetPictureVideos',
  PRDeletePictureVideos = 'DeletePictureVideos',
  PostProcessOrders = 'PostProcessOrders',
  GetPendingDetails = 'GetPendingDetails',
  ShowForm = 'ShowForm',
  PostMessages = 'PostMessages',
  SaveMessages = 'SaveMessages',
  DeleteMessages = 'DeleteMessages',
  ViewPhysicalInventory = 'ViewPhysicalInventory',
  ReversePhysicalInventory = 'ReversePhysicalInventory',
  PIENTERCOUNT = 'EnterCounts',
  PIENTERCYCLECOUNT = 'EnterCycleCounts',
  GetTransferStatusDetail = 'GetTransferStatusDetail',
  GetCreateSpoilageandloss = 'CreateSpoilageandloss',
  CreateTransfers = 'CreateTransfers',
  CreateTransfersOut = 'CreateTransfersOut',
  EditTransfers = 'EditTransfer',
  GetCreatePurchaseOrder = 'CreatePurchaseOrder',
  SaveDraftPurchaseOrder = 'SaveDraftPurchaseOrder',
  ViewPurchaseOrder = 'ViewPurchaseOrder',
  CancelRequisition = 'CancelRequisition',
  ViewFBInventory = 'ViewFBInventory',
  ViewRetailInventory = 'ViewRetailInventory',
  CreateFBInventory = 'CreateFBInventory',
  CreateRetailInventory = 'CreateRetailInventory',
  CrossReferenceFBInventory ='FBInventory',
  CrossReferenceRetailInventory ='RetailInventory',
  ViewSuppliers = 'ViewSuppliers',
  CreatePurchaseRequests = "CreatePurchaseRequests",
  PostFetchAllZones = 'FetchAllZones ',
  ReconcileInTransit = 'ReconcileInTransit',
  InTransitDelivery = 'InTransitDelivery',
  TransferAcknowledgement = 'TransferAcknowledgement'
}

export enum FieldEdmType {
  EDMINT32 = 'Edm.Int32',
  EDMSTRING = 'Edm.String',
  EDMDATEOFFSET = 'Edm.DateTimeOffset',
  EMDBOOLEAN = 'Edm.Boolean',
  EDMINT16 = 'Edm.Int16',
  EDMINTDECIMAL = 'Edm.Decimal',
  EDMFLOAT = 'Edm.Single',
  EDMDOUBLE = 'Edm.Double',
  EDMPICTURE = 'Edm.Picture',
  EDMHIDDEN = 'Edm.hidden',
  EDMMULTIDSELECT = 'Edm.Multiple',
  EDMINT64 = 'Edm.Int64'
}

export enum EntityName {
  ReqHead = 'ReqHead',
  ReqDetail = 'ReqDetails',
  PhysicalHead = 'PhysicalHead',
  PhysicalDetail = 'PhysicalDetails',
  TransferHead = 'TransferHead',
  TransferDetail = 'TransferDetails',
  PoHead = 'PurchaseOrderHead',
  PoDetail = 'PurchaseOrderDetails',
  SpoilageHead = 'SpoilageHead',
  SpoilageDetail = 'SpoilageDetails',
  ReceivingHead = 'ReceivingHead',
  ReceivingDetails = 'ReceivingDetails',
  SearchHistory = 'SearchHistory',
  TransactionPurchaseOrder = 'TransactionPurchaseOrder'
}

export enum ERRORCODE {
  CODE_400 = 400,
  CODE_500 = 500,
  CODE_401 = 400,
  CODE_403 = 403,
  CODE_404 = 404,
  CODE_406 = 406,
  CODE_408 = 408,
  CODE_405 = 405
}
export enum ERRORMESSAGE {
  ERROR_MESSAGE_400 = 'Bad Request',
  ERROR_MESSAGE_401 = 'Unauthorized',
  ERROR_MESSAGE_403 = 'Forbidden',
  ERROR_MESSAGE_500 = 'Internal Server Error',
  ERROR_MESSAGE_404 = 'Not Found',
  ERROR_MESSAGE_405 = 'Method Not Allowed',
  ERROR_MESSAGE_406 = 'Not Acceptable',
  ERROR_MESSAGE_408 = 'Request Timeout'
}

export enum BidTypes {
  Primary = "Primary",
  Secondary = "Secondary",
  LastRegion = "Last Region"
}

export enum AzureAdType {
  CUSTOMERB2C = '1',
  PRODUCTB2C = '2',
  LDAP = '3',
  NONE = '0',
  AZUREOPENID = '4',
  AZUREADSAML = '5',
  WORKOSSSO = '6'
}

export enum AzureUserFlow {
  CUSTOMERUSERFLOW  = 'CustomerAzureB2C',
  AGIYSYSUSERFLOW = 'AgilysysLocalB2C',
  LDAPUSERFLOW = 'LDAP',
  NONEUSERFLOW = 'None',
  AZUREOPENID = 'AzureADOpenId',
  AZUREADSAML = 'AzureADSAML',
  WORKOSSSO = 'WorkOSSSO'
}

export enum SearchByCategoryId {
  Classes = 2,
  Types = 3,
  Packages = 4,
}

export const CurrencySymbols = [
  {
      "Id": 1,
      "Name": "Afghan afghani",
      "Code": "AFN",
      "Symbol": "؋"
  },
  {
      "Id": 2,
      "Name": "Albanian Lek",
      "Code": "ALL",
      "Symbol": "Lek"
  },
  {
      "Id": 3,
      "Name": "Algerian Dinar",
      "Code": "DZD",
      "Symbol": "دج"
  },
  {
      "Id": 4,
      "Name": "Angolan Kwanza",
      "Code": "AOA",
      "Symbol": "Kz"
  },
  {
      "Id": 5,
      "Name": "Antillian Guilder",
      "Code": "ANG",
      "Symbol": "ƒ"
  },
  {
      "Id": 6,
      "Name": "Armenian Dram",
      "Code": "AMD",
      "Symbol": "֏"
  },
  {
      "Id": 7,
      "Name": "Aruban Guilder",
      "Code": "AWG",
      "Symbol": "ƒ"
  },
  {
      "Id": 8,
      "Name": "Australian Dollars",
      "Code": "AUD",
      "Symbol": "A$"
  },
  {
      "Id": 9,
      "Name": "Azerbaijani manat",
      "Code": "AZN",
      "Symbol": "₼"
  },
  {
      "Id": 10,
      "Name": "Bahamian Dollar",
      "Code": "BSD",
      "Symbol": "$"
  },
  {
      "Id": 11,
      "Name": "Bahraini Dinar",
      "Code": "BHD",
      "Symbol": "د.ب"
  },
  {
      "Id": 12,
      "Name": "Bangladesh Taka",
      "Code": "BDT",
      "Symbol": "৳"
  },
  {
      "Id": 13,
      "Name": "Barbados Dollar",
      "Code": "BBD",
      "Symbol": "$"
  },
  {
      "Id": 14,
      "Name": "Belize Dollar",
      "Code": "BZD",
      "Symbol": "BZ$"
  },
  {
      "Id": 15,
      "Name": "Bermudian Dollar",
      "Code": "BMD",
      "Symbol": "$"
  },
  {
      "Id": 16,
      "Name": "Bhutanese Ngultrum",
      "Code": "BTN",
      "Symbol": "Nu"
  },
  {
      "Id": 17,
      "Name": "Bolivar Fuerte",
      "Code": "ESA",
      "Symbol": "Bs"
  },
  {
      "Id": 18,
      "Name": "Bolivia Boliviano",
      "Code": "BOB",
      "Symbol": "$b"
  },
  {
      "Id": 19,
      "Name": "Bolivian Mvdol",
      "Code": "BOV",
      "Symbol": "Mvdol"
  },
  {
      "Id": 20,
      "Name": "Bosnia and Herzegovina Convertible Marks",
      "Code": "BAM",
      "Symbol": "KM"
  },
  {
      "Id": 21,
      "Name": "Botswana Pula",
      "Code": "BWP",
      "Symbol": "P"
  },
  {
      "Id": 22,
      "Name": "Brazilian Real",
      "Code": "BRL",
      "Symbol": "R$"
  },
  {
      "Id": 23,
      "Name": "Brunei Dollar",
      "Code": "BND",
      "Symbol": "$"
  },
  {
      "Id": 24,
      "Name": "Burundi Franc",
      "Code": "BIF",
      "Symbol": "FBu"
  },
  {
      "Id": 25,
      "Name": "Cambodia Riel",
      "Code": "KHR",
      "Symbol": "៛"
  },
  {
      "Id": 26,
      "Name": "Canadian Dollar",
      "Code": "CAD",
      "Symbol": "$"
  },
  {
      "Id": 27,
      "Name": "Cape Verdi Escudo",
      "Code": "CVE",
      "Symbol": "Esc"
  },
  {
      "Id": 28,
      "Name": "Cayman Islands Dollar",
      "Code": "KYD",
      "Symbol": "$"
  },
  {
      "Id": 29,
      "Name": "CFA Franc BCEAO",
      "Code": "XOF",
      "Symbol": "CFA"
  },
  {
      "Id": 30,
      "Name": "CFA Franc BEAC",
      "Code": "XAF",
      "Symbol": "FCFA"
  },
  {
      "Id": 31,
      "Name": "CFP Franc",
      "Code": "XPF",
      "Symbol": "₣"
  },
  {
      "Id": 32,
      "Name": "Chilean Peso",
      "Code": "CLP",
      "Symbol": "$"
  },
  {
      "Id": 33,
      "Name": "Chinese Yuan Renminbi",
      "Code": "CNX",
      "Symbol": "¥"
  },
  {
      "Id": 34,
      "Name": "Colombian Peso",
      "Code": "COP",
      "Symbol": "$"
  },
  {
      "Id": 35,
      "Name": "Comoro Franc",
      "Code": "KMF",
      "Symbol": "CF"
  },
  {
      "Id": 36,
      "Name": "Congolese Franc",
      "Code": "CDF",
      "Symbol": "FC"
  },
  {
      "Id": 37,
      "Name": "Costa Rican Colon",
      "Code": "CRC",
      "Symbol": "₡"
  },
  {
      "Id": 38,
      "Name": "Croatian Kuna",
      "Code": "HRK",
      "Symbol": "kn"
  },
  {
      "Id": 39,
      "Name": "Cuban convertible peso",
      "Code": "CUC",
      "Symbol": "CUC$"
  },
  {
      "Id": 40,
      "Name": "Cuban Peso",
      "Code": "CUP",
      "Symbol": "₱"
  },
  {
      "Id": 41,
      "Name": "Czech Koruna",
      "Code": "CZK",
      "Symbol": "Kč"
  },
  {
      "Id": 42,
      "Name": "Danish Krone",
      "Code": "DKK",
      "Symbol": "kr"
  },
  {
      "Id": 43,
      "Name": "Djibouti Franc",
      "Code": "DJF",
      "Symbol": "Fdj"
  },
  {
      "Id": 44,
      "Name": "Dobra",
      "Code": "STD",
      "Symbol": "Db"
  },
  {
      "Id": 45,
      "Name": "Dominican Republic Peso",
      "Code": "DOP",
      "Symbol": "RD$"
  },
  {
      "Id": 46,
      "Name": "East Caribbean Dollar",
      "Code": "XCD",
      "Symbol": "$"
  },
  {
      "Id": 47,
      "Name": "Egyptian Pound",
      "Code": "EGP",
      "Symbol": "£"
  },
  {
      "Id": 48,
      "Name": "El Salvador Colón",
      "Code": "SVC",
      "Symbol": "$"
  },
  {
      "Id": 49,
      "Name": "Eritrean Nakfa",
      "Code": "ERN",
      "Symbol": "ናቕፋ"
  },
  {
      "Id": 50,
      "Name": "Ethiopian Birr",
      "Code": "ETB",
      "Symbol": "ብር"
  },
  {
      "Id": 51,
      "Name": "Euro",
      "Code": "EUR",
      "Symbol": "€"
  },
  {
      "Id": 52,
      "Name": "Falkland Islands Pound",
      "Code": "FKP",
      "Symbol": "£"
  },
  {
      "Id": 53,
      "Name": "Fiji Dollar",
      "Code": "FJD",
      "Symbol": "$"
  },
  {
      "Id": 54,
      "Name": "Gambia Delasi",
      "Code": "GMD",
      "Symbol": "D"
  },
  {
      "Id": 55,
      "Name": "Georgian Lari",
      "Code": "GEL",
      "Symbol": "ლ"
  },
  {
      "Id": 56,
      "Name": "Ghanaian Cedi (3rd)",
      "Code": "GHS",
      "Symbol": "¢"
  },
  {
      "Id": 57,
      "Name": "Gibraltar Pound",
      "Code": "GIP",
      "Symbol": "£"
  },
  {
      "Id": 58,
      "Name": "Guatemala Quetzal",
      "Code": "GTQ",
      "Symbol": "Q"
  },
  {
      "Id": 59,
      "Name": "Guinea Franc",
      "Code": "GNF",
      "Symbol": "GFr"
  },
  {
      "Id": 60,
      "Name": "Guyanese Dollar",
      "Code": "GYD",
      "Symbol": "$"
  },
  {
      "Id": 61,
      "Name": "Haitian Gourde",
      "Code": "HTG",
      "Symbol": "G"
  },
  {
      "Id": 62,
      "Name": "Honduras Lempira",
      "Code": "HNL",
      "Symbol": "L"
  },
  {
      "Id": 63,
      "Name": "Hong Kong Dollar",
      "Code": "HKD",
      "Symbol": "$"
  },
  {
      "Id": 64,
      "Name": "Hungarian Forint",
      "Code": "HUF",
      "Symbol": "Ft"
  },
  {
      "Id": 65,
      "Name": "Iceland Krona",
      "Code": "ISK",
      "Symbol": "kr"
  },
  {
      "Id": 66,
      "Name": "Indian Rupee",
      "Code": "INR",
      "Symbol": "₹"
  },
  {
      "Id": 67,
      "Name": "Indonesian Rupiah",
      "Code": "IDR",
      "Symbol": "Rp"
  },
  {
      "Id": 68,
      "Name": "Iranian Rial",
      "Code": "IRR",
      "Symbol": "﷼"
  },
  {
      "Id": 69,
      "Name": "Iraqi Dinar",
      "Code": "IQD",
      "Symbol": "ع.د"
  },
  {
      "Id": 70,
      "Name": "Jamaican Dollar",
      "Code": "JMD",
      "Symbol": "J$"
  },
  {
      "Id": 71,
      "Name": "Japanese Yen",
      "Code": "JPY",
      "Symbol": "¥"
  },
  {
      "Id": 72,
      "Name": "Jordanian Dinar",
      "Code": "JOD",
      "Symbol": "د.ا"
  },
  {
      "Id": 73,
      "Name": "Kazakhstani Tenge",
      "Code": "KZT",
      "Symbol": "лв"
  },
  {
      "Id": 74,
      "Name": "Kenyan Shilling",
      "Code": "KES",
      "Symbol": "Ksh"
  },
  {
      "Id": 75,
      "Name": "Kuwaiti Dinar",
      "Code": "KWD",
      "Symbol": "د.ك"
  },
  {
      "Id": 76,
      "Name": "Kyrgyzstan Som",
      "Code": "KGS",
      "Symbol": "лв"
  },
  {
      "Id": 77,
      "Name": "Laos Kip",
      "Code": "LAK",
      "Symbol": "₭"
  },
  {
      "Id": 78,
      "Name": "Lebanese Pound",
      "Code": "LBP",
      "Symbol": "£"
  },
  {
      "Id": 79,
      "Name": "Lesotho Loti",
      "Code": "LSL",
      "Symbol": "M"
  },
  {
      "Id": 80,
      "Name": "Liberia Dollar",
      "Code": "LRD",
      "Symbol": "$"
  },
  {
      "Id": 81,
      "Name": "Libyan Dinar",
      "Code": "LYD",
      "Symbol": "ل.د"
  },
  {
      "Id": 82,
      "Name": "Lithuania",
      "Code": "LTL",
      "Symbol": "LTL"
  },
  {
      "Id": 83,
      "Name": "Macau Pataca",
      "Code": "MOP",
      "Symbol": "MOP$"
  },
  {
      "Id": 84,
      "Name": "Macedonian Denar",
      "Code": "MKD",
      "Symbol": "ден"
  },
  {
      "Id": 85,
      "Name": "Malagasy Ariary",
      "Code": "MGA",
      "Symbol": "Ar"
  },
  {
      "Id": 86,
      "Name": "Malawi Kwacha",
      "Code": "MWK",
      "Symbol": "MK"
  },
  {
      "Id": 87,
      "Name": "Malaysian Ringgit",
      "Code": "MYR",
      "Symbol": "RM"
  },
  {
      "Id": 88,
      "Name": "Maldives Rufiyaa",
      "Code": "MVR",
      "Symbol": "Rf"
  },
  {
      "Id": 89,
      "Name": "Manat",
      "Code": "TMT",
      "Symbol": "AZN"
  },
  {
      "Id": 90,
      "Name": "Mauritanian ouguiya",
      "Code": "MRU",
      "Symbol": "UM"
  },
  {
      "Id": 91,
      "Name": "Mauritius Rupee",
      "Code": "MUR",
      "Symbol": "₨"
  },
  {
      "Id": 92,
      "Name": "Mexican Peso",
      "Code": "MXN",
      "Symbol": "$"
  },
  {
      "Id": 93,
      "Name": "Mexican Unidad de Inversion",
      "Code": "MXV",
      "Symbol": "MXV"
  },
  {
      "Id": 94,
      "Name": "Moldovia Leu",
      "Code": "MDL",
      "Symbol": "pl"
  },
  {
      "Id": 95,
      "Name": "Mongolia Tugrik",
      "Code": "MNT",
      "Symbol": "₮"
  },
  {
      "Id": 96,
      "Name": "Moroccan Dirham",
      "Code": "MAD",
      "Symbol": "MAD"
  },
  {
      "Id": 97,
      "Name": "Mozambican Metical",
      "Code": "MZN",
      "Symbol": "MT"
  },
  {
      "Id": 98,
      "Name": "Myanmar Kyat",
      "Code": "MMK",
      "Symbol": "K"
  },
  {
      "Id": 99,
      "Name": "Namibian Dollar",
      "Code": "NAD",
      "Symbol": "N$"
  },
  {
      "Id": 100,
      "Name": "Nepalese Rupee",
      "Code": "NPR",
      "Symbol": "₨"
  },
  {
      "Id": 101,
      "Name": "New Belarusian Ruble",
      "Code": "BYN",
      "Symbol": "Br"
  },
  {
      "Id": 102,
      "Name": "New Bulgarian Lev",
      "Code": "BGN",
      "Symbol": "лв"
  },
  {
      "Id": 103,
      "Name": "New Guinea Kina",
      "Code": "PGK",
      "Symbol": "K"
  },
  {
      "Id": 104,
      "Name": "New Israeli Scheqel",
      "Code": "ILS",
      "Symbol": "₪"
  },
  {
      "Id": 105,
      "Name": "New Polish Zloty",
      "Code": "PLN",
      "Symbol": "zł"
  },
  {
      "Id": 106,
      "Name": "New Romanian Lei",
      "Code": "RON",
      "Symbol": "lei"
  },
  {
      "Id": 107,
      "Name": "New Taiwan Dollar",
      "Code": "TWD",
      "Symbol": "NT$"
  },
  {
      "Id": 108,
      "Name": "New Turkish Lira",
      "Code": "TRY",
      "Symbol": "₺"
  },
  {
      "Id": 109,
      "Name": "New Zealand Dollar",
      "Code": "NZD",
      "Symbol": "$"
  },
  {
      "Id": 110,
      "Name": "Nicaragua Cordoba Oro",
      "Code": "NIO",
      "Symbol": "C$"
  },
  {
      "Id": 111,
      "Name": "Nigerian Naira",
      "Code": "NGN",
      "Symbol": "₦"
  },
  {
      "Id": 112,
      "Name": "North Korean won",
      "Code": "KPW",
      "Symbol": "₩"
  },
  {
      "Id": 113,
      "Name": "Norwegian Krone",
      "Code": "NOK",
      "Symbol": "kr"
  },
  {
      "Id": 114,
      "Name": "Nuevo Argentine Peso",
      "Code": "ARS",
      "Symbol": "$"
  },
  {
      "Id": 115,
      "Name": "Offshore Renminbi",
      "Code": "CNH",
      "Symbol": "¥‎"
  },
  {
      "Id": 116,
      "Name": "Ouguiya",
      "Code": "MRO",
      "Symbol": "MRU"
  },
  {
      "Id": 117,
      "Name": "Pakistan Rupee",
      "Code": "PKR",
      "Symbol": "₨"
  },
  {
      "Id": 118,
      "Name": "Panamanian Balboa",
      "Code": "PAB",
      "Symbol": "B/."
  },
  {
      "Id": 119,
      "Name": "Paraguay Guarani",
      "Code": "PYG",
      "Symbol": "Gs"
  },
  {
      "Id": 120,
      "Name": "Peruvian Nuevo Sol",
      "Code": "PEN",
      "Symbol": "S/."
  },
  {
      "Id": 121,
      "Name": "Peso Uruguayo",
      "Code": "UYU",
      "Symbol": "$U"
  },
  {
      "Id": 122,
      "Name": "Philippine Peso",
      "Code": "PHP",
      "Symbol": "₱"
  },
  {
      "Id": 123,
      "Name": "British Pound Sterling",
      "Code": "GBP",
      "Symbol": "£"
  },
  {
      "Id": 124,
      "Name": "Qatari Rial",
      "Code": "QAR",
      "Symbol": "﷼"
  },
  {
      "Id": 125,
      "Name": "Reval. Belarus Ruble",
      "Code": "BYR",
      "Symbol": "Rbl‎"
  },
  {
      "Id": 126,
      "Name": "Rial Omani",
      "Code": "OMR",
      "Symbol": "﷼"
  },
  {
      "Id": 127,
      "Name": "Russian Ruble",
      "Code": "RUB",
      "Symbol": "₽"
  },
  {
      "Id": 128,
      "Name": "Rwanda Franc",
      "Code": "RWF",
      "Symbol": "FRw"
  },
  {
      "Id": 129,
      "Name": "Samoan Tala",
      "Code": "WST",
      "Symbol": "WS$"
  },
  {
      "Id": 130,
      "Name": "Sao Tome and Principe Dobra",
      "Code": "STN",
      "Symbol": "Db"
  },
  {
      "Id": 131,
      "Name": "Saudi Riyal",
      "Code": "SAR",
      "Symbol": "﷼"
  },
  {
      "Id": 132,
      "Name": "Serbian Dinar",
      "Code": "RSD",
      "Symbol": "Дин."
  },
  {
      "Id": 133,
      "Name": "Seychelles Rupee",
      "Code": "SCR",
      "Symbol": "₨"
  },
  {
      "Id": 134,
      "Name": "Sierra Leone Leone",
      "Code": "SLE",
      "Symbol": "Le"
  },
  {
      "Id": 135,
      "Name": "Sierra Leonean leone",
      "Code": "SLL",
      "Symbol": "Le"
  },
  {
      "Id": 136,
      "Name": "Singapore Dollar",
      "Code": "SGD",
      "Symbol": "$"
  },
  {
      "Id": 137,
      "Name": "Solomon Island Dollar",
      "Code": "SBD",
      "Symbol": "$"
  },
  {
      "Id": 138,
      "Name": "Somalia Shilling",
      "Code": "SOS",
      "Symbol": "S"
  },
  {
      "Id": 139,
      "Name": "South African Rand",
      "Code": "ZAR",
      "Symbol": "R"
  },
  {
      "Id": 140,
      "Name": "South Sudan Pound",
      "Code": "SSP",
      "Symbol": "£"
  },
  {
      "Id": 141,
      "Name": "South-Korean Won",
      "Code": "KRW",
      "Symbol": "₩"
  },
  {
      "Id": 142,
      "Name": "Sri Lankan Rupee",
      "Code": "LKR",
      "Symbol": "₨"
  },
  {
      "Id": 143,
      "Name": "St. Helena Pound",
      "Code": "SHP",
      "Symbol": "£"
  },
  {
      "Id": 144,
      "Name": "Sudanese pound",
      "Code": "SDG",
      "Symbol": "ج.س"
  },
  {
      "Id": 145,
      "Name": "Surinamese dollar",
      "Code": "SRD",
      "Symbol": "$"
  },
  {
      "Id": 146,
      "Name": "Swaziland Lilangeni",
      "Code": "SZL",
      "Symbol": "E"
  },
  {
      "Id": 147,
      "Name": "Swedish Krone",
      "Code": "SEK",
      "Symbol": "kr"
  },
  {
      "Id": 148,
      "Name": "Swiss Franc",
      "Code": "CHF",
      "Symbol": "CHF"
  },
  {
      "Id": 149,
      "Name": "Syrian Pound",
      "Code": "SYP",
      "Symbol": "£"
  },
  {
      "Id": 150,
      "Name": "Tajikistan Somoni",
      "Code": "TJS",
      "Symbol": "ЅM"
  },
  {
      "Id": 151,
      "Name": "Tanzanian Shilling",
      "Code": "TZS",
      "Symbol": "TSh"
  },
  {
      "Id": 153,
      "Name": "Thai Baht",
      "Code": "THB",
      "Symbol": "฿"
  },
  {
      "Id": 154,
      "Name": "Tonga Paanga",
      "Code": "TOP",
      "Symbol": "T$"
  },
  {
      "Id": 155,
      "Name": "Trinidad & Tobago Dollar",
      "Code": "TTD",
      "Symbol": "TT$"
  },
  {
      "Id": 156,
      "Name": "Tunisian Dinar",
      "Code": "TND",
      "Symbol": "د.ت"
  },
  {
      "Id": 157,
      "Name": "Emirati UAE Dirham",
      "Code": "AED",
      "Symbol": " د.إ"
  },
  {
      "Id": 158,
      "Name": "Uganda Shilling",
      "Code": "UGX",
      "Symbol": "USh"
  },
  {
      "Id": 159,
      "Name": "Ukraine Hryvnia",
      "Code": "UAH",
      "Symbol": "₴"
  },
  {
      "Id": 160,
      "Name": "Unidad de Fomento",
      "Code": "CLF",
      "Symbol": "CLF"
  },
  {
      "Id": 161,
      "Name": "Unidad de Valor Real",
      "Code": "COU",
      "Symbol": "UVR"
  },
  {
      "Id": 162,
      "Name": "United States dollar (next day) ",
      "Code": "USN",
      "Symbol": "$"
  },
  {
      "Id": 163,
      "Name": "Uruguay Peso en Unidades Indexadas",
      "Code": "UYI",
      "Symbol": "$U‎"
  },
  {
      "Id": 164,
      "Name": "US Dollars",
      "Code": "USD",
      "Symbol": "$"
  },
  {
      "Id": 165,
      "Name": "Uzbekistani Som",
      "Code": "UZS",
      "Symbol": "лв"
  },
  {
      "Id": 166,
      "Name": "Vanuatu Vatu",
      "Code": "VUV",
      "Symbol": "VT"
  },
  {
      "Id": 167,
      "Name": "Venezuelan Bolívar",
      "Code": "VEF",
      "Symbol": "Bs"
  },
  {
      "Id": 168,
      "Name": "Venezuelan digital bolivar",
      "Code": "VED",
      "Symbol": "Bs."
  },
  {
      "Id": 169,
      "Name": "Venezuelan sovereign bolivar",
      "Code": "VES",
      "Symbol": "VES"
  },
  {
      "Id": 170,
      "Name": "Vietnamese New Dong",
      "Code": "VND",
      "Symbol": "₫"
  },
  {
      "Id": 171,
      "Name": "WIR Euro",
      "Code": "CHE",
      "Symbol": "€"
  },
  {
      "Id": 172,
      "Name": "WIR franc",
      "Code": "CHW",
      "Symbol": "CHW"
  },
  {
      "Id": 173,
      "Name": "Yemeni Rial",
      "Code": "YER",
      "Symbol": "﷼"
  },
  {
      "Id": 174,
      "Name": "Yuan Renminbi",
      "Code": "CNY",
      "Symbol": "¥"
  },
  {
      "Id": 175,
      "Name": "Zambian Kwacha",
      "Code": "ZMW",
      "Symbol": "ZK"
  },
  {
      "Id": 176,
      "Name": "Zimbabwean dollar",
      "Code": "ZWL",
      "Symbol": "Z$"
  }
]

export enum ApplicationId {
  APTRAC = 19,
  BatchItemMaintanence = 6,
  DataImport = 5,
  DataMigration = 10,
  ERP = 16,
  Exchange = 4,
  IG = 8,
  InventoryControl = 7,
  Mobile = 3,
  OnDemand = 13,
  OtherPOS = 11,
  PFGImport = 14,
  SnC = 12,
  SAP = 17,
  VendorPunchOut = 9,
  VendorPunchThrough = 15,
  WebAPI = 2,
  WebClient = 1,
  WMS = 18
}
